import React, { useState } from 'react';
import './DomainChecker.css';
import { checkDomainAvailability, isValidDomain, cleanDomain } from '../services/domainService';

function DomainChecker() {
  // State management - similar to ViewState in ASP.NET WebForms
  const [domain, setDomain] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  // Event handler - similar to Button_Click in WebForms
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission
    
    if (!domain.trim()) {
      setError('Please enter a domain name');
      return;
    }

    const cleanedDomain = cleanDomain(domain);
    
    if (!isValidDomain(cleanedDomain)) {
      setError('Please enter a valid domain name (e.g., example.com)');
      return;
    }

    setIsLoading(true);
    setError('');
    setResult(null);

    try {
      // Call the real WHOIS API service
      const domainInfo = await checkDomainAvailability(domain);
      setResult(domainInfo);
    } catch (err) {
      setError(err.message || 'Error checking domain availability');
    } finally {
      setIsLoading(false);
    }
  };

  // JSX - similar to markup in .aspx files, but with JavaScript expressions
  return (
    <div className="domain-checker">
      <form onSubmit={handleSubmit} className="domain-form">
        <div className="input-group">
          <input
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="Enter domain name (e.g., example.com)"
            className="domain-input"
            disabled={isLoading}
          />
          <button 
            type="submit" 
            className="check-button"
            disabled={isLoading || !domain.trim()}
          >
            {isLoading ? 'Checking...' : 'Check Domain'}
          </button>
        </div>
      </form>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {result && (
        <div className={`result ${result.available === null ? 'unknown' : result.available ? 'available' : 'unavailable'}`}>
          <h3>{result.domain}</h3>
          <div className="status-indicator">
            {result.available === null ? '❓ Unknown' : result.available ? '✅ Available' : '❌ Taken'}
          </div>
          <p className="status-text">{result.status}</p>
          
          {result.available === false && (
            <div className="domain-details">
              {result.registrar && (
                <div className="detail-item">
                  <strong>Registrar:</strong> {result.registrar}
                </div>
              )}
              {result.creationDate && (
                <div className="detail-item">
                  <strong>Created:</strong> {new Date(result.creationDate).toLocaleDateString()}
                </div>
              )}
              {result.expirationDate && (
                <div className="detail-item">
                  <strong>Expires:</strong> {new Date(result.expirationDate).toLocaleDateString()}
                </div>
              )}
            </div>
          )}
          
          {result.error && (
            <div className="error-note">
              <small>{result.error}</small>
            </div>
          )}
          
          {result.fallbackMethod && (
            <div className="fallback-note">
              <small>⚠️ Using DNS lookup method</small>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DomainChecker;
